module.exports = __webpack_public_path__ + "static/media/createCustomTask.a509161c.png";